import React, {Component} from 'react';
import {renderRoutes} from 'react-router-config';
import {BrowserRouter} from 'react-router-dom';
import {MuiThemeProvider} from '@material-ui/core/styles';
import flow from 'lodash/flow';
import injectSheet from 'react-jss';
import JssProvider from 'react-jss/lib/JssProvider';
import mapJSONRoutes from '@makolab/library-react/dist/mapJSONRoutes';
import Messages from '@makolab/library-react/dist/Messages';
import Loading from '@makolab/library-react/dist/Loading';
import console from '@makolab/library-react/dist/console';

import {jss, generateClassName} from '../../styles/jss-config';
import themeRenault from '../../styles/theme-renault';
import themeDacia from '../../styles/theme-dacia';
import stylesRenault from '../../styles/global-renault.jss';
import stylesDacia from '../../styles/global-dacia.jss';
import routesMap from '../../routes-map';
import {HTML_BASE_NAME} from '../../commons/constants';

const ROUTES_MAP = routesMap((props) => {
  if (props.error) {
    return (
      <div>
        Error! <button onClick={props.retry}>Retry</button>
      </div>
    );
  }
  if (props.timedOut) {
    return (
      <div>
        Taking a long time... <button onClick={props.retry}>Retry</button>
      </div>
    );
  }
  if (props.pastDelay) {
    return <Loading />;
  }
  return null;
});

export class App extends Component {
  state = {
    routes: [],
    loading: true,
    error: null,
  };

  componentDidMount = () => {
    import('../../routes')
      .then((res) => {
        const mappedRoutes = mapJSONRoutes(res.default, ROUTES_MAP);
        this.setState({loading: false, routes: mappedRoutes});
      })
      .catch((err) => console.log(err));
  };

  renderRoutes = () => (
    <BrowserRouter basename={HTML_BASE_NAME}>
      {renderRoutes(this.state.routes)}
    </BrowserRouter>
  );

  render = () => {
    const {loading, error} = this.state;
    const Routes = flow([injectSheet(process.env.REACT_APP_BRAND === 'Renault' ? stylesRenault : stylesDacia)])(this.renderRoutes);

    if (error) {
      return <span>{error}</span>;
    }
    if (loading) {
      return <Loading />;
    }

    return (
      <JssProvider jss={jss} generateClassName={generateClassName}>
        <MuiThemeProvider theme={process.env.REACT_APP_BRAND === 'Renault' ? themeRenault : themeDacia}>
          <Routes />
          <Messages closeIconId="icon-close" />
        </MuiThemeProvider>
      </JssProvider>
    );
  };
}

export default App;



// WEBPACK FOOTER //
// ./src/components/app/app.js